module.exports = __webpack_public_path__ + "static/media/home-icon.b75040c2.svg";